import { createContext, useContext } from 'react';

const ACSelectionBoxContext = createContext({
  insertLeafNode: () => {},
  insertOperatorNode: () => {},
  insertDefinitionNodes: () => {},
  insertFunctionNodes: () => {},
  toggleSelectedNode: () => {},
  selectAllNodes: () => {},
  mergeSelectedNodes: () => {},
  splitSelectedNodes: () => {},
  splitSelectedOnNodes: () => {},
  removeSelectedNodes: () => {},
  removeNodesByIds: () => {},
  clearSelectionBox: () => {},
  selectAllOperators: () => {},
  changeSelectedOperator: () => {},
  changeSelectedOperatorById: () => {},
  duplicateSelectedNodes: () => {},
  copySelectedNodes: () => {},
  pasteCopiedNodes: () => {},
  setOverrideLabelById: () => {},
  setupBulkJoin: () => {},
  cancelBulkJoinSetup: () => {},
  mergeBulkJoin: () => {},
  removeFunctionById: () => {},
  changeFunctionOfSelectedNodes: () => {},
  selectAllFunctions: () => {},
  selectFunctionById: () => {},
  setSelectedLabelType: () => {},
  selectAllTemplateOperatorsByType: () => {},
  trackerFn: () => {},
  combineSelectedIntoNetAny: () => {},
  setSelectionBoxDefinitionNodes: () => {},
  setBackToRootNode: () => {}
});

export const useACSelectionBoxContext = () => useContext(ACSelectionBoxContext);

export default ACSelectionBoxContext;
